<template>
  <div class="columns">
    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Answer</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input" v-model="freeTextAnswer" type="text">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SingleAnswer',
    props: [
      'defaultValue'
    ],
    mounted() {
      if (this.defaultValue) {
        this.freeTextAnswer = this.defaultValue
      }
    },
    data() {
      return {
        freeTextAnswer: '',
      }
    },
    watch: {
      'freeTextAnswer': function () {
        this.$emit('updated', this.freeTextAnswer)
      }
    },
    methods: {
      clearForm() {
        this.freeTextAnswer = ''
      }
    }
  }
</script>

<style scoped>
  .field-label {
    flex-grow: 0;
  }
  .field-label label {
    width: 180px !important;
  }
</style>
